import React, { ReactNode } from "react";
import styled, { css } from "styled-components";
import { colors } from "@literati/public-ui-shared-react";
import MembershipFall25OfferBadge from "components/Membership/MembershipFall25OfferBadge";

export interface MembershipFall25OfferBoxProps {
  className?: string;
  withCardChrome?: boolean;
  marginTop?: string;
  topImage?: ReactNode;
}

const Container = styled.div<{
  $withCardChrome: boolean;
  $marginTop: string;
}>`
  margin-top: ${({ $marginTop }) => $marginTop};
  border-radius: 12px;
  overflow: visible;
  background: #f7f6f3;

  ${({ $withCardChrome }) =>
    $withCardChrome
      ? css`
          border: 1px solid ${colors.periwinkleShade1};
          box-shadow: 0 2px 10px 0 rgb(0 0 0 / 20%);
        `
      : css`
          border: 0;
          box-shadow: none;
        `}
`;

const OfferFirstContainer = styled.div`
  position: relative;
  padding: 1.5rem 1rem 1rem;
  text-align: left;
  background: ${colors.white};
  color: ${colors.inkBlack};
  border-radius: 11px 11px 0 0;
`;

const OfferBadgeWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 1.25rem;
  transform: translateY(-50%);
`;

const OfferMainHeading = styled.div`
  margin-top: 0.5rem;
  font-size: 1.125rem;
  font-weight: 700;
  color: ${colors.inkBlack};
`;

const OfferSubtext = styled.div`
  margin-top: 0.375rem;
  font-size: 0.875rem;
`;

const PriceContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.25rem 0.5rem;
  margin-top: 0.625rem;
`;

const MainPrice = styled.div`
  font-size: 1.25rem;
  font-weight: 900;
  line-height: 1;
  color: ${colors.tealShade2};
`;

const ComparePrice = styled.div`
  font-size: 1.25rem;
  text-decoration: line-through;
  opacity: 0.9;
  color: ${colors.warmGray1};
  font-weight: 800;
`;

const PriceText = styled.div`
  width: 100%;
  font-size: 0.875rem;
`;

const OfferSecondContainer = styled.div`
  padding: 0.75rem 1rem;
  background: ${colors.periwinkleTint5};
  border-radius: 0 0 11px 11px;
`;

const OfferNote = styled.div`
  color: ${colors.inkBlack};
  font-size: 0.8125rem;
  line-height: 1.35;
`;

export const MembershipFall25OfferBox = ({
  className = "",
  withCardChrome = true,
  marginTop = "2rem",
  topImage,
}: MembershipFall25OfferBoxProps) => {
  return (
    <Container
      className={className}
      $marginTop={marginTop}
      $withCardChrome={withCardChrome}
    >
      <OfferFirstContainer>
        {topImage}
        <OfferBadgeWrapper>
          <MembershipFall25OfferBadge />
        </OfferBadgeWrapper>
        <OfferMainHeading>First 3 months just $4.95/mo</OfferMainHeading>
        <OfferSubtext>Hand-picked stories kids love.</OfferSubtext>
        <PriceContainer>
          <MainPrice>$4.95</MainPrice>
          <ComparePrice>$11.95</ComparePrice>
          <PriceText>first 3 months</PriceText>
        </PriceContainer>
      </OfferFirstContainer>
      <OfferSecondContainer>
        <OfferNote>
          Cancel or change anytime. Monthly fee $11.95 after first 3 months.
        </OfferNote>
      </OfferSecondContainer>
    </Container>
  );
};

export default MembershipFall25OfferBox;
